import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useSearchFile } from "../../hooks/useCrm";
import Loading from "../Loadings/LoadingTable";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { SelectWrapper } from "./SearchUserStyle";
import { useNavigate } from "react-router-dom";
export const SearchUser = ({ className }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const {
    data: searcheddata,
    isLoading,
    refetch,
  } = useSearchFile({ Search: search });
  const Users = searcheddata?.data?.users;
  const inputRef = null;

  const usersOptions = Users?.map((user) => {
    return {
      value: user.IdS0alesOpportunities,
      label: user.FirstName + " " + user.LastName + " " + user.Phone,
    };
  });
  return (
    <SelectWrapper>
      <SimpleSelect1
        placeholder="جستجو در اشخاص"
        className={className}
        res={usersOptions}
        onChange={(e) => {
          if (!e) {
            e = {
              target: inputRef,
              value: "",
            };
          }
          e.value ? navigate(`customer-file/${e?.value}`) : navigate(-1);
        }}
        onMenuOpen={refetch}
        loadingMessage={() => "در حال بارگزاری"}
        isLoading={isLoading ? true : false}
      />
    </SelectWrapper>
  );
};
